module.exports = __webpack_public_path__ + "img/card_show.c7d20db4.svg";